import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, Grid, ShimmerImage, Space, ShimmerTypography } from '@pitchero/react-ui';
import ProfileHeaderStatsLoading from './header-stats-loading';

const ProfileHeaderLoading = ({ profileType }) => (
  <>
    <Space bottom="large">
      <Grid preset="profileHeader">
        <div style={{ gridArea: 'avatar' }}>
          <ShimmerImage preset="profile" />
        </div>
        <div style={{ gridArea: 'name' }}>
          <Space bottom="small">
            <ShimmerTypography preset="title--large" width="80%" style={{ maxWidth: 400 }} />
          </Space>
          <ShimmerTypography preset="tab--active" width="70%" style={{ maxWidth: 350 }} />
        </div>
        <ProfileHeaderStatsLoading profileType={profileType} />
      </Grid>
    </Space>

    <Space bottom="large">
      <Cushion all="large">
        <Space bottom="small">
          <ShimmerTypography preset="name" width="25%" style={{ maxWidth: 250 }} />
        </Space>
        <ShimmerTypography preset="body--large" width="100%" />
        <ShimmerTypography preset="body--large" width="100%" />
        <ShimmerTypography preset="body--large" width="100%" />
        <ShimmerTypography preset="body--large" width="25%" />
      </Cushion>
    </Space>
  </>
);

ProfileHeaderLoading.propTypes = {
  profileType: PropTypes.oneOf(['player', 'coach']).isRequired,
};

export default ProfileHeaderLoading;
